import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Link, Stack, Typography } from '@mui/material';

export default function PrivacyPage() {
  useEffect(() => {
    document.title = 'Privacy policy — Baton';
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: { xs: 6, md: 9 } }}>
      <Typography variant="h3" component="h1" sx={{ fontWeight: 800 }}>Privacy policy</Typography>
      <Typography color="text.secondary" sx={{ mt: 0.5, fontStyle: 'italic' }}>
        Placeholder. Final policy will be published before launch.
      </Typography>
      <Stack spacing={2} sx={{ mt: 4 }}>
        <Typography>
          Baton stores only the data needed to run your team: emails, names, school/club info, and
          the schedule data you create. Your org's data is fully isolated from every other org.
        </Typography>
        <Typography>We never sell or share your data with third parties.</Typography>
        <Typography variant="h6" sx={{ pt: 2, fontWeight: 700 }}>Email</Typography>
        <Typography>
          We send transactional emails (waitlist confirmations, schedule notifications, password resets)
          via SendGrid. You can unsubscribe at any time.
        </Typography>
        <Typography variant="h6" sx={{ pt: 2, fontWeight: 700 }}>Contact</Typography>
        <Typography>
          Questions? <Link component={RouterLink} to="/contact">Send us a message</Link>.
        </Typography>
      </Stack>
    </Container>
  );
}
